import styled from 'styled-components';

import { black } from 'constants/color';

export const StyledWrapper = styled.div``;

export const StyledDetail = styled.div`
  display: flex;
  padding: 5px 10px;
  border-bottom: 1px solid #e0e0e0;
`;

export const StyledInfo = styled.span`
  color: ${black};
  padding-left: 10px;
  border-left: 1px solid #e0e0e0;
`;

export const StyledTitle = styled.span`
  margin-right: 10px;
`;

export const StyledTable = styled.table`
  width: 100%;
  margin-top: 10px;
  border-collapse: collapse;
`;

export const StyledTableCell = styled.td`
  font-size: 12px;
  color: ${black};
  padding-left: 8px;
  border: 1px solid #dddddd;
`;

export const StyledTableHeader = styled.th`
  font-size: 12px;
  padding: 5px 8px;
  border: 1px solid #dddddd;
`;

export const StyledTableHead = styled.thead`
  text-align: left;
  border: 1px solid #dddddd;
`;

export const StyledTableRow = styled.tr`
  &:hover {
    background-color: #f4f4f4;
  }
`;

export const StyledTableBody = styled.tbody``;
